import './components/show-hide-password';
import JustValidate from 'just-validate';

// remove value where error occurs
if ( typeof signupError !== 'undefined'){
$(document).ready(function() {
        if( signupError == 'email' ){
            $('#txtEmail').val("");
            $('#txtEmail').focus();
        }
        if( signupError == 'username' ){
            $('#txtUsername').val("");
            $('#txtUsername').focus();
        }
    });
}

const strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!-\/:-@[-`{-~])(?=.{8,})");
/* 
    ^	The password string will start this way
    (?=.*[a-z])	The string must contain at least 1 lowercase alphabetical character
    (?=.*[A-Z])	The string must contain at least 1 uppercase alphabetical character
    (?=.*[0-9])	The string must contain at least 1 numeric character
    (?=.*[!-\/:-@[-`{-~])	The string must contain at least one special character
    (?=.{8,})	The string must be eight characters or longer
*/

const validate_signup = new JustValidate('#form-signup');

validate_signup
    .addField('.input-username', [{
            rule: 'required',
            errorMessage: 'Field is required',
        },
        {
            rule: 'minLength',
            value: 3,
        },
        {
            rule: 'maxLength',
            value: 30,
        },
    ])
    .addField('.input-email', [{
            rule: 'required',
            errorMessage: 'Email is required',
        },
        {
            rule: 'email',
            errorMessage: 'Email is invalid!',
        },
    ])
    .addField('.input-password', [{
            rule: 'required',
            errorMessage: 'Password is required',
        },
        {
            validator: (value) => strongRegex.test(value),
            errorMessage: 'Password should contain minimum eight characters, at least one uppercase letter, one lowercase letter, one number and one special character',
        },
    ])
    .addField('.input-password-repeat', [{
            rule: 'required',
        },
        {
            validator: (value, fields) => {
                if (
                    fields['.input-password'] &&
                    fields['.input-password'].elem
                ) {
                    const repeatPasswordValue =
                        fields['.input-password'].elem.value;
                    return value === repeatPasswordValue;
                }
                return true;
            },
            errorMessage: 'Passwords should be the same',
        },
    ])
    .onSuccess((event) => {
        document.getElementById('form-signup').submit()
    });
